import React from 'react';
import { X } from '@finect/tabular-icons/x';
import { Inner } from './partials';
export var CloseAction = function CloseAction(_ref) {
  var onAction = _ref.onAction,
    withPaddingTop = _ref.withPaddingTop,
    color = _ref.color;
  return React.createElement(Inner, {
    onClick: onAction,
    withPaddingTop: withPaddingTop,
    color: color
  }, React.createElement(X, null));
};